<template>
  <div class="top-query-list">
    <div class="top-query-list-title">精华问题</div>
    <div class="list-content">
      <div class="list-item" v-for="(item, index) in topList" :key="item.id" @click="toDetail(item.id)">
        <!-- 只显示5条相似问题 -->
        <template v-if="index < 5">
          <div class="list-item-title">{{ item.title }}</div>
          <span class="list-item-time">{{ new Date(item.updateDate).format("yyyy-MM-dd hh:mm:ss") }}</span>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { checkNoLoginRead } from "../../../api/faq";
import { getCookie } from "@/utils/common";
export default {
  name: "top-query-list",
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  computed: {
    topList() {
      let sortList = JSON.parse(JSON.stringify(this.list))
      const randomSort = () => {
        return Math.random() > 0.5 ? -1 : 1;
      }
      return sortList.sort(() => randomSort())
    }
  },
  methods: {
    toDetail(id) {
      checkNoLoginRead(id).then((res) => {
        if (res && !res.data.checkNoLoginRead) {
          let cookie = getCookie('loginKey');
          if (!cookie) {
            this.$warning({ content: '未登录，无法查看此FAQ，请先登录！' })
            return;
          }
        }
        this.$emit('toDetail', id)
      });
    },
  },
};
</script>
<style scoped lang="scss">
.top-query-list {
  width: 100%;
  height: 100%;
  padding: 26px 28px;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.06);
  color: #000000;
  overflow-y: auto;

  &-title {
    font-size: 24px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
  }
  .list-content {
    padding: 30px 0;
  }
  .list-item {
    color: #666;
    margin-bottom: 20px;
    cursor: pointer;
    &-title {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Semibold;
      font-weight: 600;
      line-height: 26px;
      color: #000000;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    &-time{
      font-size: 12px;
      color: #666666;
    }
    &:hover{
      color: #007AFF;
      .list-item-time, .list-item-title{
        color: #007AFF;
      }
    }
  }
}

</style>